import React, { FC } from "react";

const StockMove: FC = () => {
  return <div>StockMove</div>;
};

export default StockMove;
